function getSkuFromUrl (urlPath: string) {

	return urlPath.split('__')[1] ? urlPath.split('__')[1].replace('.html', '') : '';

}

export default getSkuFromUrl;
